import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Family(props: StickerArtProps) {
  return (
    <StickerFrame background="#e11d48" {...props}>
      <circle cx="21" cy="23" r="6" fill="#ffffff" />
      <circle cx="43" cy="23" r="6" fill="#ffffff" />
      <path d="M11 47 Q11 31 21 31 Q31 31 31 47 Z" fill="#ffffff" />
      <path d="M33 47 Q33 31 43 31 Q53 31 53 47 Z" fill="#ffffff" />
      <circle cx="32" cy="36" r="4.5" fill="#fde68a" stroke="#1f2937" strokeWidth="1.5" />
      <path d="M24.5 53 Q24.5 42 32 42 Q39.5 42 39.5 53 Z" fill="#fde68a" stroke="#1f2937" strokeWidth="1.5" />
    </StickerFrame>
  );
}
